import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { CartService } from 'src/app/services/cart.service';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CurrencyService } from 'src/app/services/currency.service';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.scss']
})
export class CartPageComponent implements OnInit {
  public isLogin: boolean = false;
  public processingOrder: boolean;
  public totalPrice: number;
  public paymentMethod;
  public selectedCurrency: any;
  public invoiceSelected: any;
  public isSummaryPage: boolean = false;
  private currencySubscription: Subscription;
  public displayError = false;
  public acceptedAgreement = false;
  public isOpenAgreement = false;
  public agreementHtml = '';
  public invoicesList = [];
  isMobile: boolean;

  public errorItems: Array<any>;
  constructor(
    private authorizationService: AuthorizationService,
    private cartService: CartService,
    private browserStorageService: BrowserStorageService,
    private router: Router,
    private currencyService: CurrencyService,
    private informationPageService: InformationPageService,
    private title: Title, private translateService: TranslateService
  ) {
    this.isLogin = this.authorizationService.isLogin();
    this.processingOrder = false;
    this.paymentMethod = {
      name: null,
      code: null
    }
    this.selectedCurrency = this.browserStorageService.get("_currency");

    this.currencySubscription = this.currencyService.currencyChangeEmitter.subscribe((name: string) => {
      this.getCurrency();
    });

    this.invoiceSelected = null;

    if (window.innerWidth <= 1025) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  ngOnInit(): void {
    this.translateService.get('title_cart').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }
  ngOnDestroy(): void {
    if (this.currencySubscription) {
      this.currencySubscription.unsubscribe();
    }
  }


  public fetchedInvoices(invoices) {
    this.invoicesList = invoices;
  }

  public openAgreement() {
    this.getTerm();
    this.isOpenAgreement = true;
  }
  public closeAgreement() {
    this.isOpenAgreement = false;
  }

  public getCurrency() {
    setTimeout(() => {
      this.selectedCurrency = this.browserStorageService.get("_currency");
    }, 100);
  }

  public onCreatePrimaryPage() {
    this.isSummaryPage = true;
  }
  public onCreateOrder() {
    this.processingOrder = true;
    this.createOrder();
  }

  public changeInvoice(invoice) {
    this.invoiceSelected = invoice;
  }

  public onChangePrice(i) {
    this.totalPrice = i;
  }

  public onSelectPaymentMethod(method) {
    this.paymentMethod = method.value;
  }

  private createOrder() {
    const order = {
      payment_type: this.paymentMethod.code,
      invoice: this.invoiceSelected.id,
      currency_code: this.selectedCurrency
    }
    this.cartService.createOrder(order).subscribe(data => {
      if(data.success) {
        this.processingOrder = false;
        this.cartService.changeQuantity({ count: 0 });
        if(data.message && data.message.isReduced) {
          this.displayError = true;
          this.errorItems = data.message.items;
        }
        if(data.data.url) {
          if(this.displayError) {
          setTimeout(() => {
            window.location.href = data.data.url;
          }, 5000);
          } else {
            window.location.href = data.data.url;
          }

        } else {
          if(data.data == 'ok') {
            this.router.navigate(['my-account/my-orders']);
          } else {
            this.redirect(data.data.id);
          }
          
        }
      }

    }, (err) => {
      this.processingOrder = false;
    }

    );
  }

  public onLogin(event) {
    if (event.success == true) {
      window.location.reload();
    }
  }
  public onRegister(event) {
    if (event.success == true) {
      window.location.reload();
    }
  }
  private redirect(id?) {
    this.router.navigate(['my-account/my-orders/', 'pay' ,id]);
  }

  private getTerm() {
    const lang = this.browserStorageService.get("_lang");
    this.informationPageService.getInformationPage(this.informationPageService.PAGES.TERMS_AND_CONDS, lang).subscribe((response: any) => {
      this.agreementHtml = response.data.page[Object.keys(response.data.page)[0]];
    });
  }
}
